import React from 'react';
import { ActivityIndicator, Modal, ScrollView, TextInput, View } from 'react-native';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Text } from '@/components/ui/text';
import type { Translate } from '../profileTypes';

export interface EditProfileForm {
  full_name: string;
  email: string;
}

interface EditProfileModalProps {
  visible: boolean;
  form: EditProfileForm;
  onChangeForm: (form: EditProfileForm) => void;
  loading: boolean;
  onCancel: () => void;
  onSave: () => void;
  t: Translate;
}

export function EditProfileModal({
  visible,
  form,
  onChangeForm,
  loading,
  onCancel,
  onSave,
  t,
}: EditProfileModalProps) {
  return (
    <Modal visible={visible} animationType="slide" transparent>
      <View className="flex-1 bg-black/50 justify-center items-center p-4">
        <Card className="w-full max-w-sm" style={{ maxHeight: '90%' }}>
          <CardHeader className="pb-4">
            <Text className="text-xl font-semibold text-foreground text-center">
              {t('profile.editProfileTitle')}
            </Text>
          </CardHeader>
          <ScrollView showsVerticalScrollIndicator contentContainerStyle={{ paddingBottom: 4 }}>
          <CardContent>
            <TextInput
              className="border border-gray-300 rounded-lg px-4 py-3 mb-4 bg-gray-50 text-base"
              placeholder={t('profile.fullName')}
              value={form.full_name}
              onChangeText={(text) => onChangeForm({ ...form, full_name: text })}
            />

            <TextInput
              className="border border-gray-300 rounded-lg px-4 py-3 mb-6 bg-gray-50 text-base"
              placeholder={t('profile.email')}
              value={form.email}
              onChangeText={(text) => onChangeForm({ ...form, email: text })}
              keyboardType="email-address"
              autoCapitalize="none"
            />

            <View className="flex-row gap-3">
              <Button
                variant="secondary"
                size="default"
                onPress={onCancel}
                disabled={loading}
                className="flex-1"
              >
                <Text className="font-medium">{t('profile.cancel')}</Text>
              </Button>

              <Button variant="default" size="default" onPress={onSave} disabled={loading} className="flex-1">
                {loading ? (
                  <ActivityIndicator color="white" />
                ) : (
                  <Text className="text-primary-foreground font-medium">{t('profile.save')}</Text>
                )}
              </Button>
            </View>
          </CardContent>
          </ScrollView>
        </Card>
      </View>
    </Modal>
  );
}
